import SafetyDatabaseInspectionTypes from './safetyDatabaseInspection.types';

export const hydrateInspectionForm = payload => ({
	type: SafetyDatabaseInspectionTypes.DB_HYDRATE_INSPECTION_FORM,
	payload
});

export const updateTitle = payload => ({
	type: SafetyDatabaseInspectionTypes.DB_UPDATE_TITLE,
	payload
});

export const updateInfoField = payload => ({
	type: SafetyDatabaseInspectionTypes.DB_UPDATE_INFO_FIELD,
	payload
});

export const updateObservationsField = payload => ({
	type: SafetyDatabaseInspectionTypes.DB_UPDATE_OBSERVATIONS_FIELDS,
	payload
});

export const updateUnsafeActsProcedureDeviationsField = payload => ({
	type: SafetyDatabaseInspectionTypes.DB_UPDATE_UNSAFE_ACTS_PROCEDURE_DEVIATIONS_FIELD,
	payload
});

export const updateAdditionalActProcedure = payload => ({
	type: SafetyDatabaseInspectionTypes.DB_UPDATE_ADDITIONAL_ACT_PROCEDURE,
	payload
});

export const updateComments = payload => ({
	type: SafetyDatabaseInspectionTypes.DB_UPDATE_COMMENTS,
	payload
});

export const updateViolationsField = payload => ({
	type: SafetyDatabaseInspectionTypes.DB_UPDATE_VIOLATIONS_FIELD,
	payload
});
